// eslint-disable-next-line import/prefer-default-export
export const getValueToPositive = (value) => {
  if (value === null) return '';
  return Number(value) ? 'Positive' : 'Negative';
};
